import { Box, Stack, Typography } from '@mui/material';

export function ContentBlocks({ blocks, content }) {
  if (blocks && blocks.length > 0) {
    return (
      <Stack spacing={2}>
        {blocks.map((block) => {
          if (block.type === 'text' && block.html) {
            return (
              <Box
                key={block.id}
                className="content-html"
                dangerouslySetInnerHTML={{ __html: block.html }}
              />
            );
          }
          if (block.type === 'image' && block.url) {
            return (
              <Box key={block.id} component="figure" sx={{ m: 0 }}>
                <Box
                  component="img"
                  src={block.url}
                  alt={block.caption || ''}
                  sx={{ width: '100%', borderRadius: 2 }}
                />
                {block.caption ? (
                  <Typography
                    component="figcaption"
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.75 }}
                  >
                    {block.caption}
                  </Typography>
                ) : null}
              </Box>
            );
          }
          if (block.type === 'audio' && block.url) {
            return (
              <Box key={block.id}>
                <audio controls src={block.url} style={{ width: '100%' }} />
                {block.caption ? (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
                    {block.caption}
                  </Typography>
                ) : null}
              </Box>
            );
          }
          if (block.type === 'video' && block.url) {
            return (
              <Box key={block.id}>
                <Box
                  component="video"
                  controls
                  src={block.url}
                  sx={{ width: '100%', borderRadius: 2 }}
                />
                {block.caption ? (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
                    {block.caption}
                  </Typography>
                ) : null}
              </Box>
            );
          }
          return null;
        })}
      </Stack>
    );
  }

  if (content) {
    return (
      <Box className="content-html" sx={{ whiteSpace: 'pre-wrap' }}>
        {content}
      </Box>
    );
  }

  return null;
}
